// UserByUserId.jsx
import React from 'react';
import PropTypes from 'prop-types';

import UserProfile from '../container/UserProfile.js';
import MeProfile from '../container/MeProfile.js';

import { PROFILE_TABS } from '../resource/profileConstants.js';

class UserByUserId extends React.PureComponent {
  render() {
    const { isMeProfile } = this.props;
    if (isMeProfile) {
      return <MeProfile {...this.props} />;
    }
    return <UserProfile {...this.props} />;
  }
}

UserByUserId.propTypes = {
  meId: PropTypes.string,
  userId: PropTypes.string,
  listType: PropTypes.string,
  isMeProfile: PropTypes.bool,
};

UserByUserId.defaultProps = {
  meId: null,
  userId: null,
  listType: PROFILE_TABS[0],
  isMeProfile: false,
};

export default UserByUserId;
